module.exports = __webpack_public_path__ + "static/media/bitmap-media-2@1x.6f377025.png";